import {
	getCurrentUser,
	getUserCourseData,
	setContinuePoint
} from 'Assets/js/modules/user-utils';

export default async function topicTreeJs(options = {}) {
	const topicContentCarousel = document.querySelector('.content-carousel');
	const topicTree = document.querySelector('#topic-tree');
	if (!topicTree) return;

	let quizType = '';
	if (topicContentCarousel) {
		quizType = topicContentCarousel.dataset.quiztype;
	}

	if (!topicTree) return;
	const levelSelectButton = document.querySelector('.level-selection-button');
	if (levelSelectButton) {
		levelSelectButton.addEventListener('click', () => {
			if (!topicTree) {
				return;
			}
			toggleTopicTree(topicTree);
		});
	}
	document
		.querySelector('.topic-tree__btn-open')
		.addEventListener('click', function () {
			toggleTopicTree(topicTree);
		});

	function closeTopicTreeOnClickOutside(event, topicTree) {
		if (event.target === topicTree) {
			closeTopicTree(topicTree);
		}
	}
	function toggleTopicTree(topicTree) {
		topicTree.classList.toggle('topic-tree--open');
	}
	function closeTopicTree(topicTree) {
		toggleTopicTree(topicTree);
	}
	window.addEventListener('click', (event) =>
		closeTopicTreeOnClickOutside(event, topicTree)
	);
	const closeButton = document.getElementById('topic-tree__btn-close');
	if (!closeButton) return;

	closeButton.addEventListener('click', function () {
		const topicTree = document.getElementById('topic-tree');
		topicTree.classList.remove('topic-tree--open');
	});

	//Getting Course Data
	const userData = await getUserCourseData();

	const userDashboard = document.querySelector('section.user-dashboard');
	if (userDashboard?.dataset?.newuser) {
		return;
	}

	updateTreeStatus(topicTree, userData);

	const allTopicSections = topicTree.querySelectorAll('.topic-tree__content');
	allTopicSections.forEach((section) => {
		section.addEventListener('click', (e) => {
			if (!e.target.classList.contains('topic-tree-item')) {
				section.classList.toggle('topic-tree__content--selected');
			}
		});

		if (
			!document.body.classList.contains('single-topic') ||
			section.dataset.postid != document.body.dataset.currentpostid
		) {
			const topicItems = section.querySelectorAll('.topic-tree-item');
			topicItems.forEach((topicItem, index) => {
				let slideindex = topicItem.dataset.slideindex - 1;
				if (topicItem.classList.contains('topic-tree__quiz-link')) {
					slideindex = topicItems[index - 1].dataset.slideindex;
				}
				topicItem.addEventListener('click', async (e) => {
					const link = topicItem.dataset.topiclink;
					window.location.href = link + '?slide=' + slideindex;
				});
			});
		}
	});
}

function updateTreeStatus(topicTree, userData) {
	if (!userData) return;
	if (!topicTree) return;
	const levelSections = topicTree.querySelectorAll('.topic-tree__level');
	const topicTreeContainer = topicTree.querySelector(
		'.topic-tree__container'
	);

	levelSections.forEach((levelSection) => {
		const levelData = userData.level_data[levelSection.dataset.levelid];
		if (levelData.open || levelData.passed) {
			levelSection.classList.remove('locked');
		}
		const levelQuiz = topicTree.querySelector(
			`.topic-tree__level-quiz[data-levelid="${levelSection.dataset.levelid}"]`
		);
		if (levelData.end_of_level_quiz_unlocked) {
			levelQuiz.classList.remove('locked');
		}
		const moduleSections = levelSection.querySelectorAll(
			'.topic-tree__module'
		);
		if (!moduleSections) {
			return;
		}
		moduleSections.forEach((moduleSection) => {
			const moduleData =
				userData.module_data[moduleSection.dataset.moduleid];
			if (moduleData.module_passed || moduleData.open) {
				moduleSection.classList.remove('locked');
			}
			if (moduleData.end_of_module_quiz_unlocked) {
				const endOfModuleQuiz = moduleSection.querySelector(
					'.topic-tree__module-quiz'
				);
				if (endOfModuleQuiz) {
					endOfModuleQuiz.classList.remove('locked');
				}
			}
		});
		const topicSections =
			levelSection.querySelectorAll('.topic-tree__topic');
		if (!topicSections) {
			return;
		}

		topicSections.forEach((topicSection, index) => {
			const topicData = userData.topic_data[topicSection.dataset.postid];
			if (topicData.topic_passed || topicData.open) {
				topicSection.classList.remove('locked');
			}
			if (
				topicSection.dataset.postid ==
					document.body.dataset.currentpostid ||
				userData.continue_point == topicSection.dataset.postid
			) {
				topicSection.classList.add('topic-tree__content--current');
				topicSection.classList.add('topic-tree__content--selected');
				topicTreeContainer.scrollTop = topicSection.offsetTop - 25;
			}
			const topicTreeItems =
				topicSection.querySelectorAll('.topic-tree-item');
			if (!topicTreeItems) return;

			topicTreeItems.forEach((topicTreeItem, index) => {
				if (topicData.slides_viewed) {
					if (topicData.slides_viewed.includes(index)) {
						topicTreeItem.classList.add('topic-tree-item--viewed');
					}
				}
			});
		});
	});
}
